export default __webpack_public_path__ + "static/media/Circular.d377f4d3.woff2";